export enum DownloadCloud {
  Marketing = "marketing",
}
